import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormControlValidators } from '@forms';
import { TranslateService } from '@i18n';
import { FeatureMultiPlanTranslationDictionary } from '../../i18n/feature-multi-plan-dictionary.interface';
import { ApplianceDetailsFormField } from '../../models/appliance-details-form-field.enum';
import { ApplianceDetailsForm } from '../../models/appliance-details-form.interface';

@Injectable()
export class ApplianceDetailsFormBuilder {
  private readonly formBuilder = inject(FormBuilder);
  private readonly translateService = inject(
    TranslateService<FeatureMultiPlanTranslationDictionary>,
  );

  build(): FormGroup<ApplianceDetailsForm> {
    return this.formBuilder.nonNullable.group(this.buildFormConfig());
  }

  private buildFormConfig(): ApplianceDetailsForm {
    return {
      [ApplianceDetailsFormField.Manufacturer]: new FormControl(
        null,
        FormControlValidators.required(
          this.translateService.translate(
            'APPLIANCE_DETAILS_FORM_MANUFACTURER_REQUIRED',
          ),
        ),
      ),
      [ApplianceDetailsFormField.PurchaseMonth]: new FormControl(null),
      [ApplianceDetailsFormField.PurchasePrice]: new FormControl(
        null,
        FormControlValidators.required(
          this.translateService.translate(
            'APPLIANCE_DETAILS_FORM_PURCHASE_PRICE_REQUIRED',
          ),
        ),
      ),
      [ApplianceDetailsFormField.PurchaseYear]: new FormControl(
        null,
        FormControlValidators.required(
          this.translateService.translate(
            'APPLIANCE_DETAILS_FORM_PURCHASE_YEAR_REQUIRED',
          ),
        ),
      ),
      [ApplianceDetailsFormField.WasBoughtWithin12Months]: new FormControl(
        null,
        FormControlValidators.required(
          this.translateService.translate(
            'APPLIANCE_DETAILS_FORM_WAS_PURCHASED_IN_THE_LAST_YEAR_REQUIRED',
          ),
        ),
      ),
    };
  }
}
